"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CEFRLevelsAndVocabCount = exports.CEFRLevel = void 0;
var CEFRLevel;
(function (CEFRLevel) {
    CEFRLevel["A0"] = "A0";
    CEFRLevel["A1"] = "A1";
    CEFRLevel["A2"] = "A2";
    CEFRLevel["B1"] = "B1";
    CEFRLevel["B2"] = "B2";
    CEFRLevel["C1"] = "C1";
    CEFRLevel["C2"] = "C2";
})(CEFRLevel = exports.CEFRLevel || (exports.CEFRLevel = {}));
exports.CEFRLevelsAndVocabCount = [
    { activeVocabCount: 0, level: CEFRLevel.A0 },
    { activeVocabCount: 300, level: CEFRLevel.A1 },
    { activeVocabCount: 600, level: CEFRLevel.A2 },
    { activeVocabCount: 1200, level: CEFRLevel.B1 },
    { activeVocabCount: 2500, level: CEFRLevel.B2 },
    { activeVocabCount: 5000, level: CEFRLevel.C1 },
    { activeVocabCount: 10000, level: CEFRLevel.C2 },
];
//# sourceMappingURL=language_progress.js.map